import React from 'react';
import * as S from './styled';

export const ButtonMenu = props => {
  return (
    <S.ButtonHamburger
      aria-label={props.label}
      onClick={props.handleClick}
      className={props.isActive ? 'active' : ''}
    >
      <span></span>
    </S.ButtonHamburger>
  );
};

export default ButtonMenu;
